import React, { useState } from 'react';
import { Button, TextField, Box } from '@mui/material';

const CommentForm = ({ onCommentSubmit }) => {
  const [comment, setComment] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
    const trimmed = comment.trim();
    if (!trimmed) return;
    onCommentSubmit(trimmed);
    setComment('');
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
      <TextField
        fullWidth
        variant="outlined"
        label="Write a comment..."
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        multiline
        rows={4}
        placeholder="Share your thoughts with the community"
      />
      <Button type="submit" variant="contained" sx={{ mt: 2 }} disabled={!comment.trim()}>
        Post Comment
      </Button>
    </Box>
  );
};
export default CommentForm;
